import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { EyeClosed } from "../../assets/EyeClosed";
import { EyeOpen } from "../../assets/EyeOpen";
import { HelpMessage, IconBox, Input, InputContainer, Label, PasswordFieldContainer } from "./PasswordField.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A simple password field component
 *
 * @param disabled If the input is disabled
 * @param error If the input has an error
 * @param helpGutter If the help message has a gutter
 * @param helpMessage Help message to be displayed
 * @param onClick Click event
 * @param onBlur Blur event
 * @param onFocus Focus event
 * @param label Label of the input
 * @param placeholder Placeholder of the input
 * @param size Size of the input. Defaults to 'md', can be 'lg'
 * @param value Value of the input
 */
const PasswordField = /*#__PURE__*/React.forwardRef((props, ref) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const {
    disabled,
    error,
    helpGutter = true,
    helpMessage,
    label,
    name,
    onClick,
    onBlur,
    onFocus,
    placeholder,
    size = 'md',
    value,
    ...rest
  } = props;
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(PasswordFieldContainer, {
    size: size,
    disabled: disabled,
    children: [label && /*#__PURE__*/_jsx(Label, {
      htmlFor: name,
      children: label
    }), /*#__PURE__*/_jsxs(InputContainer, {
      isFocused: isFocused,
      size: size,
      error: error,
      children: [/*#__PURE__*/_jsx(Input, {
        ...rest,
        type: isVisible ? 'text' : 'password',
        name: name,
        ref: ref,
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        onClick: onClick,
        onBlur: e => {
          setIsFocused(false);
          onBlur?.(e);
        },
        onFocus: e => {
          setIsFocused(true);
          onFocus?.(e);
        }
      }), /*#__PURE__*/_jsx(IconBox, {
        onClick: () => setIsVisible(!isVisible),
        children: isVisible ? /*#__PURE__*/_jsx(EyeOpen, {
          size: size,
          color: theme?.colors?.neutralL5
        }) : /*#__PURE__*/_jsx(EyeClosed, {
          size: size,
          color: theme?.colors?.neutralL5
        })
      })]
    }), helpGutter && /*#__PURE__*/_jsx(HelpMessage, {
      error: error,
      children: helpMessage
    })]
  });
});
PasswordField.displayName = 'PasswordField';
export { PasswordField };